<template>
  <div class="page" :style="bgStyle">
    <!-- Los botones se posicionan sobre el fondo, lado derecho arriba de la foto -->
    <div class="botones-col">
      <img
        src="/mexa/boton-encuesta.png"
        class="btn-nav"
        alt="Encuesta"
        @click="$router.push('/encuesta')"
      />
      <img
        src="/mexa/boton-fotos.png"
        class="btn-nav"
        alt="Fotos"
        @click="$router.push('/video?modo=foto')"
      />
      <img
        src="/mexa/boton-video.png"
        class="btn-nav"
        alt="Video"
        @click="$router.push('/video?modo=video')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InicioView',
  data() {
    return {
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    bgStyle() {
      const img = this.isMobile ? '/mexa/fondo-inicio-movil.jpg' : '/mexa/fondo-inicio.jpg'
      return {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat'
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768
    }
  }
}
</script>

<style scoped>
.page {
  width: 100%;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

/* Botones posicionados donde indica el diseño */
.botones-col {
  position: absolute;
  top: clamp(14%, 22vh, 26%);
  right: clamp(18%, 23vw, 27%);
  display: flex;
  flex-direction: column;
  gap: clamp(8px, 1.2vh, 16px);
  align-items: flex-start;
}

.btn-nav {
  display: block;
  width: clamp(160px, 18vw, 300px);
  height: auto;
  cursor: pointer;
  transition: transform 0.15s, filter 0.15s;
}
.btn-nav:hover  { transform: scale(1.04); filter: brightness(1.08); }
.btn-nav:active { transform: scale(0.97); }

/* MOBILE */
@media (max-width: 768px) {
  .botones-col {
    top: 37%;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    align-items: center;
    gap: 12px;
  }
  .btn-nav { width: clamp(180px, 65vw, 280px); }
}
</style>
